export const getSimplifiedError = (error, field) => {
  if (error.response?.status === 500)
    return 'Please contact us at support@peakmindllc.com';
  const errorResponse = error.response && error.response.data;
  if (!errorResponse) {
    return 'Something went wrong, please try again later';
  }

  return getErrors(errorResponse);
};

const getErrors = (errorResponse) => {
  let errors = [];
  Object.keys(errorResponse).forEach(
    (error) => (errors = [...errors, ...errorResponse[error]])
  );
  // Return the first error message as a string, or join all errors
  return errors.length > 0 ? errors[0] : 'An error occurred';
};
